import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  so_ct1: z.string().nullable(),
  so_ct2: z.string().nullable(),

  report_filtering: z.string().nullable(),
  data_analysis_struct: z.string().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  so_ct1: '',
  so_ct2: '',
  report_filtering: '0',
  data_analysis_struct: ''
};
